import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import AgentMetadata from '../metadata/agent_metadata';
import ApiMetadata from '../metadata/api_metadata';
import Communicator from 'models/communicator';
import ConversationItem from 'models/conversation_item';
import ItemContent from '../item_content';
import RoutingItemType from 'models/routing_item_type';
import RoutingPhrasesContainer from '../routing/routing_phrases';

export default function RoutingItem({ item }) {
  const content = _.get(item, 'initiator.type') === Communicator.API ? getApiMetadata() : getAgentMetadata();

  return (
    <ItemContent className="routingItem" isAuditItem isInbound={false} item={item}>
      {content}
    </ItemContent>
  );

  function getApiMetadata() {
    return (
      <ApiMetadata item={item} prepositionalPhrases={renderRoutingPhrases()} text={getMetadataText(item.content)} />
    );
  }

  function getAgentMetadata() {
    return (
      <AgentMetadata
        iconClass={getIconClasses(item.content)}
        item={item}
        prepositionalPhrases={renderRoutingPhrases()}
        subject=""
        text={getMetadataText(item.content)}
      />
    );
  }

  function renderRoutingPhrases() {
    return (
      <RoutingPhrasesContainer
        initiatorId={_.get(item, 'initiator.id')}
        routingContent={item.content}
        initiatorType={_.get(item, 'initiator.type')}
      />
    );
  }
}

RoutingItem.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

function getIconClasses(routingItem) {
  switch (routingItem.itemType) {
    case RoutingItemType.BLIND_TRANSFER:
      return 'icon-phone-filled';
    default:
      return 'fa fa-exchange';
  }
}

function getMetadataText(routingItem) {
  switch (routingItem.itemType) {
    case RoutingItemType.BLIND_TRANSFER:
    case RoutingItemType.REASSIGNED_CHAT:
    case RoutingItemType.DECLINED_REASSIGNED_CHAT:
      return '';

    default:
      return 'Routed';
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/audit/routing_item.jsx